import React from 'react';
import { ListItemText, Tooltip } from '@material-ui/core';
import { trainer } from '../../../../model/trainer';

export const TrainerInfo = (props: { trainer: trainer, classes: any }) => {
    const { trainer } = props;

    let text = '';
    if (trainer.name)
        text = `${trainer.name}`;

return <Tooltip title=''>
        <ListItemText primary={text} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { display: 'block' } }} />
    </Tooltip>
}